
  (function () {
    'use strict';

    var fab = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-fab');
    var panel = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-panel');
    var back = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-back');
    if (!fab || !panel || !back) return;

    var root = document.documentElement;
    var KEY = 'benistie-a11y';

    /* ⚠️ קריטי כפול ·
       1. הערכה עוטפת את הסקשן ב-section שעשוי לשאת overflow או
          transform, ואב כזה שובר position:fixed לכל מה שבתוכו.
       2. היעד הוא html ולא body: הזום פועל על body, וכשהממשק
          יושב מעליו הוא לא מתנפח, והאיפוס תמיד נשאר בהישג יד. */
    var skip = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-skip');
    (function detach() {
      var host = document.documentElement;
      [back, panel, fab, skip].forEach(function (n) {
        if (n && n.parentNode !== host) host.appendChild(n);
      });
    })();
    var FONT_MAX = 180;
    var FONT_MIN = 90;
    var ZOOMS = [100, 110, 125, 150];

    /* מצב יחיד ומרוכז. כל מה שנשמר יושב כאן, ואין מצב נסתר בשום מקום */
    var st = {
      kb: false, anim: false, readfont: false, spacing: false, links: false,
      heads: false, alt: false, guide: false, mask: false, noimg: false, bw: false,
      mode: '', cursor: '', font: 100, zoom: 100, wordsp: 0, lettersp: 0
    };

    function load() {
      try {
        var raw = window.localStorage.getItem(KEY);
        if (!raw) return;
        var got = JSON.parse(raw);
        for (var k in st) {
          if (Object.prototype.hasOwnProperty.call(got, k)) st[k] = got[k];
        }
      } catch (e) {}
    }
    function save() {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(st));
      } catch (e) {}
    }

    /* ── תיאור לתמונות ── */
    var tip = null;
    function tipEl() {
      if (!tip) {
        tip = document.createElement('div');
        tip.className = 'a11y-tip';
        document.documentElement.appendChild(tip);
      }
      return tip;
    }
    function showTip(img) {
      var txt = (img.getAttribute('alt') || '').trim();
      if (!txt) txt = 'Esta imagen no tiene descripción';
      var t = tipEl();
      t.textContent = txt;
      t.classList.add('is-on');
      var r = img.getBoundingClientRect();
      var top = r.top - 8;
      t.style.top = (top < 60 ? r.bottom + 8 : top - t.offsetHeight) + 'px';
      var left = r.left + r.width / 2 - t.offsetWidth / 2;
      if (left < 8) left = 8;
      if (left + t.offsetWidth > window.innerWidth - 8) left = window.innerWidth - t.offsetWidth - 8;
      t.style.left = left + 'px';
    }
    function hideTip() {
      if (tip) tip.classList.remove('is-on');
    }
    function altOn() {
      var imgs = document.querySelectorAll('img');
      Array.prototype.forEach.call(imgs, function (im) {
        if (im.closest('#a11y-sections--21324002689114__e_negishot_hcWeWX-panel')) return;
        if (!im.hasAttribute('data-a11y-title')) {
          im.setAttribute('data-a11y-title', im.getAttribute('title') || '');
        }
        im.setAttribute('title', (im.getAttribute('alt') || '').trim() || 'Esta imagen no tiene descripción');
        if (!im.hasAttribute('tabindex')) im.setAttribute('tabindex', '0');
      });
    }
    function altOff() {
      var imgs = document.querySelectorAll('img[data-a11y-title]');
      Array.prototype.forEach.call(imgs, function (im) {
        var was = im.getAttribute('data-a11y-title');
        if (was) im.setAttribute('title', was);
        else im.removeAttribute('title');
        im.removeAttribute('data-a11y-title');
      });
      hideTip();
    }

    /* ── מדריך ומסכת קריאה ── */
    var guideBar = null, maskT = null, maskB = null;
    function moveGuide(y) {
      if (guideBar) guideBar.style.top = y + 'px';
      if (maskT) {
        maskT.style.top = '0px';
        maskT.style.height = Math.max(0, y - 60) + 'px';
      }
      if (maskB) {
        maskB.style.top = y + 60 + 'px';
        maskB.style.height = Math.max(0, window.innerHeight - y - 60) + 'px';
      }
    }
    function onMove(e) {
      var y = e.touches && e.touches[0] ? e.touches[0].clientY : e.clientY;
      if (typeof y === 'number') moveGuide(y);
    }
    function guideSync() {
      if (st.guide && !guideBar) {
        guideBar = document.createElement('div');
        guideBar.className = 'a11y-guide-bar';
        document.documentElement.appendChild(guideBar);
      }
      if (!st.guide && guideBar) {
        guideBar.parentNode.removeChild(guideBar);
        guideBar = null;
      }
      if (st.mask && !maskT) {
        maskT = document.createElement('div');
        maskB = document.createElement('div');
        maskT.className = 'a11y-mask-t';
        maskB.className = 'a11y-mask-b';
        document.documentElement.appendChild(maskT);
        document.documentElement.appendChild(maskB);
      }
      if (!st.mask && maskT) {
        maskT.parentNode.removeChild(maskT);
        maskB.parentNode.removeChild(maskB);
        maskT = maskB = null;
      }
      if (st.guide || st.mask) {
        document.addEventListener('mousemove', onMove);
        document.addEventListener('touchmove', onMove, { passive: true });
        moveGuide(Math.round(window.innerHeight / 2));
      } else {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
      }
    }

    /* ── החלה · מקור אמת יחיד ── */
    function apply() {
      root.classList.toggle('a11y-kb', !!st.kb);
      root.classList.toggle('a11y-anim', !!st.anim);
      /* עצירת וידאו שמתנגן לבד · WCAG 2.2.2, בלי להסתיר את הווידאו */
      try {
        var vids = document.body ? document.body.querySelectorAll('video') : [];
        for (var vi = 0; vi < vids.length; vi++) {
          var v = vids[vi];
          if (st.anim) {
            if (v.autoplay || !v.paused) {
              v.setAttribute('data-a11y-was-playing', v.paused ? '0' : '1');
              v.pause();
            }
          } else if (v.getAttribute('data-a11y-was-playing') === '1') {
            v.removeAttribute('data-a11y-was-playing');
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        }
      } catch (e) {}
      root.classList.toggle('a11y-readfont', !!st.readfont);
      root.classList.toggle('a11y-space', !!st.spacing);
      /* ריווח מילים ואותיות · שלוש רמות, מחלקה אחת פעילה לכל סוג */
      for (var sp = 1; sp <= 3; sp++) {
        root.classList.toggle('a11y-ws' + sp, st.wordsp === sp);
        root.classList.toggle('a11y-ls' + sp, st.lettersp === sp);
      }
      root.classList.toggle('a11y-links', !!st.links);
      root.classList.toggle('a11y-heads', !!st.heads);
      root.classList.toggle('a11y-guide', !!st.guide);
      root.classList.toggle('a11y-mask', !!st.mask);

      root.classList.toggle('a11y-mono', st.mode === 'mono');
      root.classList.toggle('a11y-bw', st.mode === 'bw');
      root.classList.toggle('a11y-light', st.mode === 'light');
      root.classList.toggle('a11y-invert', st.mode === 'invert');

      root.classList.toggle('a11y-cur-dark', st.cursor === 'dark');
      root.classList.toggle('a11y-cur-light', st.cursor === 'light');

      /* גודל טקסט · על html, כך שכל יחידות rem בערכה גדלות איתו */
      root.style.fontSize = st.font === 100 ? '' : st.font + '%';

      /* זום · על body בלבד. הפאנל והכפתור יושבים על html,
         אז הם לא מתנפחים והאיפוס נשאר תמיד בהישג יד */
      if (document.body) {
        document.body.style.zoom = st.zoom === 100 ? '' : st.zoom / 100;
      }
      hideImages(st.noimg);

      if (st.alt) altOn();
      else altOff();

      guideSync();
      paint();
      save();
    }

    function hideImages(on) {
      var id = 'a11y-noimg-style';
      var tag = document.getElementById(id);
      if (on && !tag) {
        tag = document.createElement('style');
        tag.id = id;
        tag.textContent =
          'body img,body picture,body video{visibility:hidden !important}';
        document.head.appendChild(tag);
      }
      if (!on && tag) tag.parentNode.removeChild(tag);
    }

    /* ── בועית הסבר לכלים · הדפוס המקובל, מעל הכפתור עצמו ── */
    var ttip = null, ttipTimer = 0, ttipFor = null;
    function helpOf(el) {
      return el && el.closest ? el.closest('[data-a11y-help]') : null;
    }
    function toolTipEl() {
      if (!ttip) {
        ttip = document.createElement('div');
        ttip.className = 'a11y-tool-tip';
        ttip.id = 'a11y-sections--21324002689114__e_negishot_hcWeWX-tooltip';
        ttip.setAttribute('role', 'tooltip');
        document.documentElement.appendChild(ttip);
      }
      return ttip;
    }
    function showToolTip(btn) {
      var txt = btn.getAttribute('data-a11y-help');
      if (!txt) return;
      clearTimeout(ttipTimer);
      var t = toolTipEl();
      t.textContent = txt;
      t.classList.remove('is-below');
      t.classList.add('is-on');
      if (ttipFor && ttipFor !== btn) ttipFor.removeAttribute('aria-describedby');
      btn.setAttribute('aria-describedby', 'a11y-sections--21324002689114__e_negishot_hcWeWX-tooltip');
      ttipFor = btn;
      var r = btn.getBoundingClientRect();
      var w = t.offsetWidth, h = t.offsetHeight;
      var pr = panel.getBoundingClientRect();
      var left = r.left + r.width / 2 - w / 2;
      var min = pr.left + 8, max = pr.right - w - 8;
      if (left < min) left = min;
      if (left > max) left = max;
      var top = r.top - h - 9;
      if (top < 8) {
        top = r.bottom + 9;
        t.classList.add('is-below');
      }
      t.style.left = left + 'px';
      t.style.top = top + 'px';
      t.style.setProperty('--ax', (r.left + r.width / 2 - left) + 'px');
    }
    function hideToolTip() {
      clearTimeout(ttipTimer);
      if (ttip) ttip.classList.remove('is-on');
      if (ttipFor) {
        ttipFor.removeAttribute('aria-describedby');
        ttipFor = null;
      }
    }
    panel.addEventListener('mouseover', function (e) {
      var b = helpOf(e.target);
      if (b) showToolTip(b);
    });
    panel.addEventListener('mouseout', function (e) {
      if (helpOf(e.relatedTarget) !== ttipFor) hideToolTip();
    });
    panel.addEventListener('focusin', function (e) {
      var b = helpOf(e.target);
      if (b) showToolTip(b);
      else hideToolTip();
    });

    /* ── סימון הכפתורים בפאנל ── */
    var badge = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-badge');
    function anyActive() {
      return !!(st.kb || st.anim || st.readfont || st.spacing || st.links ||
        st.heads || st.alt || st.guide || st.mask || st.noimg ||
        st.mode || st.cursor || st.font !== 100 || st.zoom !== 100 ||
        st.wordsp || st.lettersp);
    }
    function mark(btn, on) {
      btn.classList.toggle('is-on', !!on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    function paint() {
      var i, list;
      if (badge) badge.hidden = !anyActive();
      /* הערך מוצג כמילה ולא כספרה, כדי שיהיה מובן כמו האחוזים בגודל טקסט */
      var SPW = ("Normal,Medio,Amplio,Muy amplio").split(',');
      var wl = panel.querySelector('[data-a11y-wordsplvl]');
      var ll = panel.querySelector('[data-a11y-lettersplvl]');
      if (wl) wl.textContent = SPW[st.wordsp] || String(st.wordsp);
      if (ll) ll.textContent = SPW[st.lettersp] || String(st.lettersp);
      var spb = panel.querySelectorAll('[data-a11y-sp]');
      for (i = 0; i < spb.length; i++) {
        var parts = spb[i].getAttribute('data-a11y-sp').split('-');
        var cur = st[parts[0]];
        spb[i].disabled = parts[1] === 'up' ? cur >= 3 : cur <= 0;
      }
      list = panel.querySelectorAll('[data-a11y-toggle]');
      for (i = 0; i < list.length; i++) mark(list[i], st[list[i].getAttribute('data-a11y-toggle')]);
      list = panel.querySelectorAll('[data-a11y-mode]');
      for (i = 0; i < list.length; i++) mark(list[i], st.mode === list[i].getAttribute('data-a11y-mode'));
      list = panel.querySelectorAll('[data-a11y-cursor]');
      for (i = 0; i < list.length; i++) mark(list[i], st.cursor === list[i].getAttribute('data-a11y-cursor'));

      var fl = panel.querySelector('[data-a11y-fontlvl]');
      if (fl) fl.textContent = st.font + '%';
      var zl = panel.querySelector('[data-a11y-zoomlvl]');
      if (zl) zl.textContent = st.zoom + '%';

      /* כפתור שהגיע לקצה הטווח מושבת · ברור מיד שאין לאן להמשיך */
      var fu = panel.querySelector('[data-a11y-font="up"]');
      var fd = panel.querySelector('[data-a11y-font="down"]');
      if (fu) fu.disabled = st.font >= FONT_MAX;
      if (fd) fd.disabled = st.font <= FONT_MIN;
      var zu = panel.querySelector('[data-a11y-zoom="up"]');
      var zdn = panel.querySelector('[data-a11y-zoom="down"]');
      if (zu) zu.disabled = st.zoom >= ZOOMS[ZOOMS.length - 1];
      if (zdn) zdn.disabled = st.zoom <= ZOOMS[0];
    }

    /* ── פתיחה וסגירה ── */
    var lastFocus = null;
    var ourOpen = false;
    function lockPage() {
      root.style.overflow = 'hidden';
      if (document.body) document.body.style.overflow = 'hidden';
    }
    function unlockPage() {
      root.style.overflow = '';
      if (document.body) document.body.style.overflow = '';
    }

    function open() {
      ourOpen = true;
      lastFocus = document.activeElement;
      panel.hidden = false;
      back.hidden = false;
      lockPage();
      /* פריים אחד לפני הוספת המחלקה, אחרת המעבר לא מצויר */
      window.requestAnimationFrame(function () {
        panel.classList.add('is-open');
        back.classList.add('is-open');
      });
      fab.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        var x = panel.querySelector('[data-a11y-close]');
        if (x) x.focus();
      }, 80);
    }
    function close() {
      ourOpen = false;
      hideToolTip();
      panel.classList.remove('is-open');
      back.classList.remove('is-open');
      unlockPage();
      fab.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        panel.hidden = true;
        back.hidden = true;
      }, 320);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function isOpen() {
      return panel.classList.contains('is-open');
    }

    /* ── התפנות מפני מודאלים של האתר ──
       עגלה, תפריט נייד, זום תמונה וכמעט כל מודאל נועלים את גלילת
       הדף כשהם נפתחים. הדף נעול ולא על ידינו? מודאל פתוח, הכפתור
       מתפנה. הנעילה משתחררת? הכפתור חוזר. עובד עם כל ערכה. */
    function siteModalOpen() {
      if (ourOpen || !document.body) return false;
      var cb = window.getComputedStyle(document.body);
      if (cb.overflow === 'hidden' || cb.overflowY === 'hidden' || cb.position === 'fixed') return true;
      var ch = window.getComputedStyle(root);
      return ch.overflow === 'hidden' || ch.overflowY === 'hidden';
    }
    var yieldPoll = 0;
    function yieldSync() {
      var hide = siteModalOpen();
      fab.classList.toggle('is-yield', hide);
      /* בדיקה חוזרת · כל עוד הכפתור מוסתר, נבדוק כל 1.5 שניות אם
         הנעילה עדיין קיימת. מודאל אמיתי פתוח? נשארים מוסתרים כמה
         זמן שצריך. הנעילה שוחררה בלי שאף אחד הודיע, למשל סקריפט
         שנכשל באמצע? חוזרים. בלי ניחוש ובלי היעלמות לנצח. */
      if (hide && !yieldPoll) {
        yieldPoll = setInterval(function () {
          if (!siteModalOpen()) {
            clearInterval(yieldPoll);
            yieldPoll = 0;
            fab.classList.remove('is-yield');
          }
        }, 1500);
      } else if (!hide && yieldPoll) {
        clearInterval(yieldPoll);
        yieldPoll = 0;
      }
    }
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(yieldSync);
      mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    yieldSync();

    /* ── מייל דיווח · נבנה ברגע הלחיצה עם כתובת הדף הנוכחי ──
       קידוד ידני באחוזים ולא בפלוסים, כי תוכנות מייל לא מפענחות
       פלוס כרווח. המציין [קישור] בגוף מוחלף בכתובת האמיתית. */
    var report = document.getElementById('a11y-sections--21324002689114__e_negishot_hcWeWX-report');
    if (report) {
      report.addEventListener('click', function () {
        var subj = "Aviso sobre accesibilidad web";
        var body = "Hola,\nQuiero comunicar una incidencia de accesibilidad.\n\nPágina:\n[Enlace]\n\nDescripción:";
        if (!body) body = "Hola,\\nQuiero comunicar una incidencia de accesibilidad.\\n\\nPágina:\\n[Enlace]\\n\\nDescripción:\\n";
        /* ⚠️ iOS · ספארי נכשל על mailto ארוך מדי ועל שורות חדשות
           מקודדות בעברית. לכן: נתיב הדף בלבד ולא כתובת מלאה,
           CRLF שהוא הקידוד התקני למייל, וגג אורך עם נסיגה
           לכותרת בלבד, כדי שהמייל תמיד ייפתח. */
        var page = window.location.pathname + window.location.search;
        if (page.length > 120) page = window.location.pathname;
        page = window.location.host + page;
        body = body.replace('[Enlace]', page).replace(/\n/g, '\r\n');
        var base = 'mailto:vivarrosoporte@gmail.com?subject=' + encodeURIComponent(subj);
        var full = base + '&body=' + encodeURIComponent(body);
        report.href = full.length > 1800 ? base : full;
      });
    }

    var pbody = panel.querySelector('.a11y-body');
    if (pbody) pbody.addEventListener('scroll', hideToolTip, true);

    fab.addEventListener('click', function () {
      if (isOpen()) close();
      else open();
    });
    back.addEventListener('click', close);
    panel.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var hb = helpOf(t);
      if (hb) {
        showToolTip(hb);
        ttipTimer = setTimeout(hideToolTip, 2200);
      }
      var spBtn = t.closest('[data-a11y-sp]');
      if (spBtn) {
        var sp = spBtn.getAttribute('data-a11y-sp').split('-');
        var next = st[sp[0]] + (sp[1] === 'up' ? 1 : -1);
        st[sp[0]] = next < 0 ? 0 : (next > 3 ? 3 : next);
        save(); apply(); paint();
        return;
      }

      if (t.closest('[data-a11y-close]')) {
        close();
        return;
      }
      if (t.closest('[data-a11y-reset]')) {
        reset();
        return;
      }

      var b = t.closest('[data-a11y-toggle]');
      if (b) {
        var k = b.getAttribute('data-a11y-toggle');
        st[k] = !st[k];
        apply();
        return;
      }
      b = t.closest('[data-a11y-mode]');
      if (b) {
        var m = b.getAttribute('data-a11y-mode');
        st.mode = st.mode === m ? '' : m;
        apply();
        return;
      }
      b = t.closest('[data-a11y-cursor]');
      if (b) {
        var c = b.getAttribute('data-a11y-cursor');
        st.cursor = st.cursor === c ? '' : c;
        apply();
        return;
      }
      b = t.closest('[data-a11y-font]');
      if (b) {
        var dir = b.getAttribute('data-a11y-font');
        st.font += dir === 'up' ? 10 : -10;
        if (st.font > FONT_MAX) st.font = FONT_MAX;
        if (st.font < FONT_MIN) st.font = FONT_MIN;
        apply();
        return;
      }
      b = t.closest('[data-a11y-zoom]');
      if (b) {
        var zd = b.getAttribute('data-a11y-zoom');
        var zi = ZOOMS.indexOf(st.zoom);
        if (zi < 0) zi = 0;
        zi += zd === 'down' ? -1 : 1;
        if (zi < 0) zi = 0;
        if (zi > ZOOMS.length - 1) zi = ZOOMS.length - 1;
        st.zoom = ZOOMS[zi];
        apply();
      }
    });

    function reset() {
      st = {
        kb: false, anim: false, readfont: false, spacing: false, links: false,
        heads: false, alt: false, guide: false, mask: false, noimg: false, bw: false,
        mode: '', cursor: '', font: 100, zoom: 100, wordsp: 0, lettersp: 0
      };
      apply();
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close();
      /* לכידת פוקוס · הפאנל הוא דיאלוג, טאב מסתובב רק בתוכו.
         דרישת WCAG 2.4.3, בלעדיה הפוקוס בורח לדף המוחשך מאחור */
      if (e.key === 'Tab' && isOpen()) {
        var f = panel.querySelectorAll('button:not([disabled]), a[href]');
        if (f.length) {
          var first = f[0];
          var last = f[f.length - 1];
          var cur = document.activeElement;
          if (!panel.contains(cur)) {
            e.preventDefault();
            first.focus();
          } else if (e.shiftKey && cur === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && cur === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }
      /* קיצור מקלדת · Alt ואות שנבחרה בהגדרות */
      var key = 'a';
      if (key && e.altKey && String(e.key).toLowerCase() === key.toLowerCase()) {
        e.preventDefault();
        if (isOpen()) close();
        else open();
      }
    });

    /* התמונות בדף עשויות להיטען מאוחר · מרעננים את התיאורים בעדינות */
    document.addEventListener('mouseover', function (e) {
      if (!st.alt) return;
      var im = e.target;
      if (im && im.tagName === 'IMG' && !im.closest('#a11y-sections--21324002689114__e_negishot_hcWeWX-panel')) showTip(im);
    });
    document.addEventListener('mouseout', function (e) {
      if (st.alt && e.target && e.target.tagName === 'IMG') hideTip();
    });
    document.addEventListener('focusin', function (e) {
      if (st.alt && e.target && e.target.tagName === 'IMG') showTip(e.target);
    });
    document.addEventListener('focusout', hideTip);

    /* עורך התבניות של שופיפיי מצייר את הסקשן מחדש בכל שינוי
       הגדרה, בלי להריץ את הסקריפט שוב. נולד עותק כפול של הפאנל
       והכפתור בתוך הסקשן, והצל שלו מדמם לתוך הדף. מוחקים כל
       עותק שאינו העותק החי שכבר יושב על html. רענון מלא של
       התצוגה ממילא טוען הכל נקי עם ההגדרות החדשות. */
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      var dupes = e.target.querySelectorAll('.a11y-panel, .a11y-back, .a11y-fab, .a11y-skip');
      Array.prototype.forEach.call(dupes, function (n) {
        if (n !== panel && n !== back && n !== fab && n !== skip && n.parentNode) {
          n.parentNode.removeChild(n);
        }
      });
      apply();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.detail || e.detail.sectionId !== 'sections--21324002689114__e_negishot_hcWeWX') return;
      [panel, back, fab, skip, ttip, tip].forEach(function (n) {
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
    });

    load();
    apply();
  })();
